import { MatTableDataSource } from '@angular/material/table';
import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, ElementRef, Input, SimpleChanges } from '@angular/core';
import { Action } from 'src/models/action.model';
import { WorkflowService } from '../services/workflow.service';
import { Subscription } from 'rxjs';
import { DateUtil } from '../utils/date-util';
import { AuthenticationService } from '../services/authentication.service';
import { AppConstants } from '../constants/app-constants';
import { Utility } from '../utils/app-utils';
import { MediaComponent } from '../media/media.component';
import { MatDialog } from '@angular/material/dialog';
import { Alarm } from 'src/models/alarm.model';

@Component({
	selector: 'app-action-history',
	templateUrl: './action-history.component.html',
	styleUrls: ['./action-history.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class ActionHistoryComponent implements OnInit, OnDestroy {
	actions: Action[] = [];
	actionsDataSource: any;
	displayedColumns = ['timeStamp', 'message', 'name'];
	actionHistorySubscription: Subscription;
	utility = Utility;
	@Input() alarm: Alarm;

	constructor(
		private workflowService: WorkflowService, private authService: AuthenticationService,
		private changeDetector: ChangeDetectorRef, public dialog: MatDialog
	) { }

	async ngOnChanges(changes: SimpleChanges) {
		this.actionsDataSource = new MatTableDataSource<Action>(this.actions);
		this.actionsDataSource.data = [];
		if (changes?.alarm?.currentValue) {
			await this.updateAlarmActions(changes?.alarm?.currentValue);
		}
	}

	async ngOnInit() {
		this.actionsDataSource = new MatTableDataSource<Action>(this.actions);
		this.actionsDataSource.data = [];
		this.actionHistorySubscription = this.workflowService.getActionHistoryChangeListener().subscribe((actions: Action[]) => {
			this.actions = actions;
			this.actionsDataSource.data = this.actions;
			this.refreshComponent();
		});
	}

	async updateAlarm(alarm: Alarm) {
		await this.updateAlarmActions(alarm);
	}

	async updateAlarmActions(alarm: Alarm) {
		this.alarm = alarm;
		this.actionsDataSource.data = this.actions;
		await this.workflowService.fetchActionHistory(this?.alarm?.id);
		this.workflowService.actionHistory = this.alarm ? this.workflowService.actionHistory : [];
		this.workflowService.actionHistoryChangeListener.next(this.workflowService.actionHistory);
		this.refreshComponent();
	}

	ngOnDestroy() {
		this.actionHistorySubscription = Utility.Unsubscribe(this.actionHistorySubscription);
	}

	/**
	 * Returns date in specific format of particular timezone.
	 * @param Time Activation time in milliseconds.
	 */
	getDate(Time: any) {
		return DateUtil.getFormattedDate(Time, AppConstants.DATE_TIME_FORMAT, this.authService.getUserTimezone());
	}

	/**
	 * We are manually detecting changes to improve performance of page.
	 * Please call this function whenever you make changes.
	 */
	private refreshComponent() {
		this.changeDetector.markForCheck();
	}

	// Media display
	displayMedia(element: any) {
		this.dialog.open(MediaComponent, {
			height: '55%',
			width: '40%',
			disableClose: true,
			panelClass: 'custom-dialog',
			data: element
		});
	}

}
